import {
  Dialog,
  DialogContent,
} from '@/components/ui/dialog'
import CreateLesson from './CreateLesson/CreateLesson'

const AddLessonModal = ({ isOpen, onClose, id, seriesName }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <CreateLesson 
          seriesName={seriesName} 
          seriesId={id} 
          onFinished={() => {
            onClose();
          }}
        />
      </DialogContent>
    </Dialog>
  )
}

export default AddLessonModal
